/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Funnel = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.9645 4.49156C21.8176 4.15936 21.5773 3.87698 21.2729 3.67876C20.9685 3.48054 20.6131 3.37501 20.2498 3.375H3.74982C3.38663 3.37504 3.03126 3.48055 2.7269 3.67873C2.42254 3.8769 2.18229 4.15921 2.03534 4.49135C1.88839 4.82348 1.84106 5.19114 1.8991 5.54967C1.95715 5.90819 2.11807 6.24214 2.36232 6.51094L2.37357 6.52406L8.62482 13.1953V20.25C8.62477 20.5895 8.71687 20.9226 8.8913 21.2138C9.06574 21.505 9.31595 21.7434 9.61526 21.9035C9.91457 22.0637 10.2517 22.1395 10.5908 22.1231C10.9298 22.1066 11.2581 21.9984 11.5404 21.81L14.5404 19.8103C14.7973 19.6389 15.0078 19.4068 15.1534 19.1345C15.299 18.8622 15.375 18.5581 15.3748 18.2494V13.1953L21.6251 6.52406L21.6364 6.51094C21.8808 6.24228 22.0419 5.90843 22.1001 5.54995C22.1584 5.19146 22.1113 4.82378 21.9645 4.49156ZM13.4333 11.9813C13.2364 12.1889 13.1261 12.4638 13.1248 12.75V18.0487L10.8748 19.5487V12.75C10.8745 12.4644 10.7656 12.1895 10.5701 11.9813L4.61513 5.625H19.3845L13.4333 11.9813Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8737 1.97466C15.7576 1.71216 15.5677 1.48905 15.3272 1.33242C15.0867 1.1758 14.8058 1.09242 14.5188 1.09241H1.48138C1.19441 1.09244 0.913617 1.17581 0.673128 1.3324C0.43264 1.48899 0.242806 1.71205 0.126691 1.97448C0.0105762 2.23692 -0.0268204 2.52743 0.0190449 2.81071C0.0649101 3.094 0.192063 3.35787 0.385053 3.57026L0.393943 3.58063L5.33335 8.85189V14.4261C5.33331 14.6944 5.40608 14.9575 5.54391 15.1876C5.68174 15.4177 5.87944 15.6061 6.11594 15.7326C6.35244 15.8592 6.61885 15.9191 6.88675 15.9061C7.15465 15.8931 7.414 15.8076 7.63712 15.6588L10.0076 14.0787C10.2105 13.9433 10.3769 13.7599 10.4919 13.5447C10.6069 13.3296 10.667 13.0893 10.6668 12.8453V8.85189L15.6055 3.58063L15.6144 3.57026C15.8075 3.35798 15.9348 3.09419 15.9808 2.81093C16.0268 2.52768 15.9896 2.23715 15.8737 1.97466ZM9.13272 7.89261C8.97718 8.05672 8.89003 8.27393 8.88901 8.50003V12.6868L7.11118 13.872V8.50003C7.11095 8.27434 7.02488 8.05718 6.87043 7.89261L2.16511 2.87024H13.8351L9.13272 7.89261Z"
        fill="#002967"
      />
    </svg>
  );
};

export default Funnel;
